import React from 'react'
import { navigateTo } from 'gatsby-link'
import styled, { css } from 'styled-components'
import { VelocityComponent } from 'velocity-react'
import Link from 'gatsby-link'
import Responsive from 'react-responsive';
import { Carousel } from '../../index'

import { media, breakpoints } from '../../../styles/utils'
import { container, bgIcon, padding, hoverState, bgImage } from '../../../styles/global'
import { ribbon } from '../../../styles/colors';
import { heading } from '../../../styles/type';

class BlockRecentProjects extends React.Component {

	state = {
	
	}

	getProjects = () => {
		const { recent_projects } = this.props;

		return recent_projects.map((project, i) => {
			return (
				<Project
					to={`/project/${project.slug}`}
					key={i}
				>
					<Image
						image={project.hero_image.sizes.medium_large}
					/>
					<Title>{project.title}</Title>
				</Project>
			)
		})
	}

	renderSlider = () => {
		return (
			<Carousel
				slides={this.getProjects()}
				ref={this.slider}
				styles={carouselStyles}
				settings={{
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					speed: 1000,
					arrows: false,
					dots: false,
					dragging: true,
					centerMode: true,
					centerPadding: '32px',
				}}
			/>
		)
	}

	renderProjects = () => {
		return (
			<Projects>
				{this.getProjects()}
			</Projects>
		)
	}
	
	render() {        
		return (
			<Wrapper>
				<Top>
					<Heading>Recent Projects</Heading>
					<Button
						to={'/projects'}
					>
						View all projects
					</Button>
				</Top>

				{/* Projects Grid */}

				<Responsive minWidth={breakpoints.phone}>
					{this.renderProjects()}
				</Responsive>

				{/* Projects Slider */}

				<Responsive maxWidth={breakpoints.phone}>
					{this.renderSlider()}
				</Responsive>
			</Wrapper>
		)
	}
}

const Wrapper = styled.div`
	width: 1440px;
	max-width: 100%;
	padding: 0 15rem;
	box-sizing: border-box;
	position: relative;

	${media.tablet`
		padding: 0 10rem;
	`}

	${media.phone`
		padding: 0 40px;
	`}
`


const Heading = styled.div``
const Button = styled(Link)``

const Top = styled.div`
	position: relative;
	display: flex;
	justify-content: flex-end;
	margin-bottom: 7.5rem;

	${media.phone`
		justify-content: space-between;
		margin-bottom: 40px;
	`}

	${Heading} {
		position: absolute;
		top: 1rem;
		left: 50%;
		transform: translateX(-50%);
		font-family: 'Scto';
		font-size: 24px;
		line-height: 24px;
		text-align: center;

		${media.laptop`
			font-size: 16px;
			line-height: 16px;
		`}

		${media.tablet`
			font-size: 18px;
			line-height: 18px;
		`}

		${media.phone`
			position: static;
			transform: none;
			margin-top: 4px;
			text-align: left;
		`}
	}

	${Button} {
		height: 50px;
		padding-left: 20px;
		padding-right: 20px;
		font-family: 'Scto';
		font-size: 16px;
		line-height: 1;
		background: rgba(255,255,255,0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		transition: background 0.25s ease;

		&:hover {
			background: rgba(255,255,255,1);
		}

		${media.laptop`
			font-size: 12px;
			height: 37px;
		`}
	}
`


const Projects = styled.div`
	display: flex;
	width: 100%;
`

// Project

const Project = styled(Link)`
	position: relative;
	display: flex;
	flex-direction: column;
	flex: 0 1 33.3%;

	&:not(:last-child) {
		margin-right: 5rem;
	}

	${media.phone`
		display: block;
		margin: 0 10px;
	`}
`

const Image = styled.div`
	background-image: url(${props => props.image});
	${bgImage}
	height: 323px;
	width: 100%;

	${media.laptop`
		height: 229px;
	`}

	${media.tablet`
		height: 169px;
	`}

	${media.phone`
		height: 198px;
	`}
`

const Title = styled.div`
	font-family: 'Scto';
	font-size: 16px;
	line-height: 16px;
	margin-top: 10px;

	${media.laptop`
		font-size: 13.5px;
		line-height: 18px;
	`}

	${media.phone`
		font-size: 12px;
	`}
`

// Slider

const carouselStyles = css`
	position: relative;
	overflow: hidden;
	width: 100vw;
	transform: translateX(-40px);
`

BlockRecentProjects.wrapper = css`
	display: flex;
	flex-direction: column;
	align-items: center;
`

export default BlockRecentProjects



// WEBPACK FOOTER //
// ./src/components/Block/templates/BlockRecentProjects.js